const Template = `
<div class="page-content">
	<left-menu :modems="modems" @line-click="modemClick" :selectedModemLogs="selectedModemLogs"></left-menu>
	
	<info-window v-if="selectedModem" :selected="selectedModem" @data-load="onSelectedDataLoad"></info-window>
</div>`;

export { Template };



// WEBPACK FOOTER //
// ./src/app/js/components/onewire/template.js